import Api from '@/api/api.js'

export default {
    
    /**
     * Route pour recuperer les ventes  
     */
    getVentes (data) {
        const promise = Api().post('/ventes', data)
        return promise.then((response) => response.data)
    },

    /**
     * Livraison
     */
    livraison (id, utilisateur) {
        const promise = Api().post('/livraison-vente/'+id, utilisateur)
        return promise.then((response) => response.data)
    },
}